import fetch from 'auth/FetchInterceptor'

const LeadService = {
  getAll: (params = null) =>
    fetch({ url: '/crm/leads', method: 'get', params }),
  get: (id) => fetch({ url: `/crm/leads/${id}`, method: 'get' }),
  create: (data) => fetch({ url: '/crm/leads', method: 'post', data }),
  update: (id, data) =>
    fetch({ url: `/crm/leads/${id}`, method: 'patch', data }),
  remove: (id) => fetch({ url: `/crm/leads/${id}`, method: 'delete' }),
  move: (id, payload = {}) =>
    fetch({ url: `/crm/leads/${id}/move`, method: 'post', data: payload }),
  convert: (id, payload = {}) =>
    fetch({ url: `/crm/leads/${id}/convert`, method: 'post', data: payload }),
}

export default LeadService
